export function topicCategoryReducer(state, action) {
  switch (action.type) {
    case "loadTopicCategories":
      return {
        ...state,
        topicCategories: action.topicCategories,
      };
    case "moveCategory":
      return {
        ...state,
        topicCategories: action.topicCategories,
      };

    case "showModal":
      return {
        ...state,
        showModal: true,
        currentTopicCategory: action.currentTopicCategory,
      };
    case "hideModal":
      return {
        ...state,
        showModal: false,
        currentTopicCategory: null,
      };
    default:
      throw new Error();
  }
}
